/**
 * Clean a pasted biological sequence: drop FASTA header lines (starting with
 * `>`), whitespace, digits and other non-letters, and uppercase the rest.
 */
export function cleanSequence(input: string): string {
  return input
    .split("\n")
    .filter((line) => !line.trimStart().startsWith(">"))
    .join("")
    .replace(/[^A-Za-z]/g, "")
    .toUpperCase();
}

/** Count each residue in a sequence. */
export function residueCounts(seq: string): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const ch of seq) counts[ch] = (counts[ch] ?? 0) + 1;
  return counts;
}

const DNA_RNA = new Set(["A", "C", "G", "T", "U", "N"]);

/** True if every residue is a plain unambiguous DNA/RNA base (A/C/G/T/U/N). */
export function isNucleotide(seq: string): boolean {
  return seq.length > 0 && [...seq].every((ch) => DNA_RNA.has(ch));
}
